import { initHints } from './utils/hintsFactory';

const STORAGE_VERSION = 'v1';
const STORAGE_NAME = `tariff-summary`;

const { storageAtom, syncAtom, updateAllAtom, gettersAndRemovers } = initHints({
  storageName: STORAGE_NAME,
  storageVersion: STORAGE_VERSION,
  initialValues: {
    accounts: [],
  } as {
    accounts: string[];
  },
});
const { accounts } = gettersAndRemovers;

export const atomWithStorage = storageAtom;
export const syncHintsAtom = syncAtom;
export const tariffSummaryUpdateHintsAtom = updateAllAtom;

export const tariffSummaryAccountsHintsAtom = accounts;
